module.exports = __webpack_public_path__ + "../resources/img/ic_snow_wind_weather.c98aea04.svg";